import React from 'react';
import { bool, shape, string } from 'prop-types';

const Sample = ({
  className = 'icon',
  notUseClass = false,
  style = { color: 'currentColor' },
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19ZM11 14.5399V11H12H13V14.5399C12.8584 14.6473 12.6873 14.7615 12.507 14.8507C12.2906 14.9577 12.1187 15 12 15C11.8813 15 11.7094 14.9577 11.493 14.8507C11.3127 14.7615 11.1416 14.6473 11 14.5399ZM14 11C14 10.4477 13.5523 10 13 10C13 9.91044 12.9882 9.82363 12.9661 9.74104L14.3536 8.35359L13.6465 7.64648L12.2591 9.03389C12.1764 9.01178 12.0896 9 12 9C11.9104 9 11.8236 9.01178 11.741 9.03387L10.3536 7.64648L9.64648 8.35359L11.0339 9.74098C11.0118 9.82359 11 9.91042 11 10C10.4477 10 10 10.4477 10 11V11.5H9.20711L8.35355 10.6465L7.64645 11.3536L8.79289 12.5H10V13.5H8.79289L7.64645 14.6464L8.35355 15.3536L9.20711 14.5H10V14.5858C10 14.851 10.1044 15.1071 10.3122 15.2719C10.6855 15.568 11.3427 16 12 16C12.6573 16 13.3145 15.568 13.6878 15.2719C13.8956 15.1071 14 14.851 14 14.5858V14.5H14.7929L15.6464 15.3536L16.3536 14.6464L15.2071 13.5H14V12.5H15.2071L16.3536 11.3536L15.6464 10.6465L14.7929 11.5H14V11Z" fill="currentColor" />
  </svg>
);

Sample.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Sample;
